import { useEffect } from 'react';

import { SessionStorageManager } from '@atlas/core';

import { REDIRECT_DATA_AFTER_DEPOSIT } from 'src/common/constants';

const useRedirectAfterDeposit = () => {
  useEffect(() => {
    const redirectData = SessionStorageManager.getItem(REDIRECT_DATA_AFTER_DEPOSIT);

    if (!redirectData) return;

    const { expirationTime, url } = JSON.parse(redirectData);

    SessionStorageManager.removeItem(REDIRECT_DATA_AFTER_DEPOSIT);

    if (Date.now() < expirationTime && url) {
      window.location.href = url;
    }
  }, []);
};

export default useRedirectAfterDeposit;
